// URL からホスト名を安全に取り出す小さなユーティリティ。
//
// リンクカードの表示（link-card-object.tsx）とサムネイル描画（canvas-thumbnail.ts）で
// 「サイト名が無いときに何を出すか」を一致させるため、両方から同じ実装を参照する。

/** URL からホスト名を返す。解釈できない文字列は元の値をそのまま返す。 */
export function safeHostname(url: string): string {
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
}
